module.exports = __webpack_public_path__ + "static/media/article-image.9a131a19.png";